import LZString from "lz-string";

import { FINBOX_USER } from "../../shared/context/AuthContext";
import { CustomLoaderFunctionArgs } from "../../shared/router/RouteLoader";
import { getProductTypes } from "../../shared/context/utils";
import { getRenderStrategy } from "@unified-dashboard/src/core/access-control";
import { PRODUCT_TYPES, SEARCH_TYPES } from "../../services/Partners/constants";

import usePartnersStore from "../Partners/store";
import { ORG_IDS } from "@unified-dashboard/src/shared/utils/constants";

type Mode = "onboarded" | "pending" | "rejected";

export const STATUS_MAP: Record<Mode, number> = {
  pending: 0,
  rejected: 2,
  onboarded: 1,
};

export default async function partnersListLoader({
  request,
  getToken,
  pageName,
  authContextData, //Pass context data from AuthContext since we cannot use AuthContext inside any loader
}: CustomLoaderFunctionArgs & { authContextData?: any }) {
  console.log("Partners Loader called");
  const url = new URL(request.url);
  const { getPartnersList, getChannelsList, getPartnerPagePermissions } = usePartnersStore.getState();
  const searchParams = new URLSearchParams(url.search);
  const page = +(searchParams.get("page") ?? 1);
  const status = searchParams.get("status") || undefined;
  const productTypeParam = searchParams.get("productType") || "all";
  const searchTypeParam = searchParams.get("searchType") ?? "";
  const searchTextParam = searchParams?.get("searchText") ?? "";
  const token = getToken();
  let productTypes = searchParams.get("productType") || "all";
  if (productTypes == "all") {
    productTypes = "";
  }
  const finboxUser = JSON.parse(
    LZString.decompress(localStorage?.getItem(FINBOX_USER)) ?? "{}"
  );
  const userType = finboxUser?.userType ?? "";

  const { isConfigDrivenTabContent } = getRenderStrategy();
  const isHFCL = finboxUser?.organizationID === ORG_IDS.HFCL;

  await getPartnersList({
    limit: 10,
    page,
    token,
    searchType: searchTypeParam ?? "",
    searchText: searchTextParam ?? "",
    filters: [],
    productType: productTypes,
    pageName,
    status,
  });
  await getChannelsList({
    pages: [],
    token,
    searchType: searchTypeParam ?? "",
    searchText: searchTextParam ?? "",
    productType: productTypes,
    pageName,
    dsaID: "",
    type: "full",
    userType: userType!,
  });
  
  isHFCL && await getPartnerPagePermissions({
    organizationID: finboxUser.organizationID,
    userID: finboxUser.email,
    token,
    pageName
  });

  usePartnersStore.setState({
    productType: productTypes,
    searchText: searchTextParam,
    searchType: searchTypeParam,
    status,
  });

  const productType =
    getProductTypes()?.find((pType) => pType.value === productTypeParam) ||
    PRODUCT_TYPES[0];
  // console.log(
  //   PRODUCT_TYPES.filter((p) => getProductTypes().includes(p.value)).find(
  //     (pType) => pType.value === productTypeParam
  //   ),
  //   PRODUCT_TYPES.filter((p) => getProductTypes().includes(p.value))
  // );

  const searchType =
    SEARCH_TYPES.find((p) => p.value == searchTypeParam) || SEARCH_TYPES[0];

  return {
    searchText: searchTextParam,
    searchType,
    productType,
  };
}
